module.exports = __webpack_public_path__ + "assets/img/3b7c-je.svg";